<template>
    <div>
        <el-container>
            <el-header style="padding: 0px; height: 50px;">
                <navbar></navbar>
            </el-header>
            <el-main style="padding: 0px">
                <router-view></router-view>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import Navbar from "@/components/Navbar";
    // import BaimoFooter from "@/components/BaimoFooter";

    export default {
        name: "Main",
        data() {
            return {
                width: this.$store.state.showAsidebar + "px"
            }
        },
        mounted() {
            // console.log(this.$store.state.showAsidebar)
        },
        components: {
            Navbar,
            // BaimoFooter
        }
    }
</script>

<style>
</style>
